export enum PinnedStatusEnum {
  pinned = 'pinned',
  unpinned = 'unpinned',
}
